var map = {
	"./ai-boat-project-pcb-boat.png": 16,
	"./ai-boat-project-pcb.png": 17,
	"./ai-boat-project.jpg": 18,
	"./demographics-mapping.png": 19,
	"./geoso-website.png": 20,
	"./local-news-backend.png": 21,
	"./local-news-mobile.png": 22,
	"./multirotor-aircraft.jpg": 23
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51;